
import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';
import Aztec from './Aztec.png';
import SmallH1 from './HexagonSmall1.jpg';
import SmallH2 from './HexagonSmall2.jpg';
import SmallH3 from './HexagonSmall3.jpg';
import SmallH4 from './HexagonSmall4.jpg';
import Lozplustile from './hexplustiles.jpg';
import bell from './bell.jpg';
import TW from './TW.jpg';

import BigHcircle from './HexagonBigCircle.jpg';



const classes= {
    root : {
        flexGrow: 1,
        padding: 5,
        backgroundColor: '#b2dfdb',
        color: '#6a737b',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 30,
        elevation: '20',
    },
    h1 : {
    paddingLeft: 0 ,
    color: '#009688',
    marginTop:0,
    marginBottom:10,
    marginLeft:0 },
   
    p :{
        color: '#333333' ,
        paddingLeft: 0,
        marginTop:30,
        marginBottom: 30},
    pImag :{
            color: '#333333' ,
            paddingLeft: 'auto',
            paddingRight: 'auto',
            paddingTop: '3%',
            justifyContent: 'center',
            alignItems: 'center',}   
          
    }

export class Research extends Component {

    render() {
        return ( 
            <div style={{align:'left', margin:'7%',marginTop:70, backgroundColor: '#E6EBE9',
            padding:'3%'}}>
        <Grid  container  spacing={0} style={{marginLeft:0, paddingBottom:50, borderLeft: '0.03em solid grey'}}>
        <Grid item xs={12} sm={6} style={{margin:0, paddingTop:0, paddingLeft:'3%',paddingRight:'3%'}} >
        <Typography variant="h4" style={classes.h1}>
            My Research
        </Typography>
        <Typography  style={classes.p}> 
            Here you will find some information about my research interests and activities. 
        </Typography>
        <Typography variant="h4" style={classes.h1}>
            Research interests
        </Typography>
        <Typography  style={classes.p}> 
                Most of my research is on random matrices and integrable probability.  I am interested in universality phenomena 
            in the asymptotic behavior of microsopic systems when such systems are large. 
        </Typography>

        <Typography  style={classes.p}> 
                In 2021 I received an ERC consolidator grant for the project "Patterns in Random Tilings" (PiRaT). The overall goal of this project is study the behavior of random tilings of large planar domains and related models and their integables structure. If you wonder what random tilings of planar domains are and why they are interesting then you can read the popular research description below.
        </Typography>
        <Typography paragraph style={classes.p}> 
                Some key words:
          
       <ul style={{margin: '30px 0px', color: '#009688'}}>
        <li style={{marginBottom:20}}>  
                <span style={{color: '#333333'}}> Determinantal point process: eigenvalues of random matrices, random tilings,
                interlacing particle systems, non-colliding processes
                </span>
       </li>
       <li style={{marginBottom:20}}>
           <span style={{color: '#333333'}}>
                Universality: CLTs on macroscopic and mesoscopic scales and log-correlated fields, bulk and edge universality, critical phenomena.
                </span>
       </li>

       <li style={{marginBottom:30}}>
       <span style={{color: '#333333'}}>
       Asymptotic analysis: Plancherel-Rotach asymptotics for orthogonal polynomials,
                    spectra and determinants of large Toeplitz matrices,
                     Riemann-Hilbert problems, steepest descent techniques. 
                     </span>
       </li >
       <li style={{marginBottom:30}}>
       <span style={{color: '#333333'}}>
       Special functions: orthogonal polynomials,  Painlevé transcendents.
       </span>
       </li>

           </ul>
           </Typography>
                
           <Grid item xs={12} sm={12} style={{margin:0, paddingTop:0, paddingLeft:'3%',paddingRight:'3%'}} >
        <Typography variant="h4" style={classes.h1}>
            Postdocs and PhDs
        </Typography>
        <Grid  container spacing={0} style={{marginLeft:0, paddingBottom:50}}>
            <Grid item xs={6} sm={6} style={{margin:0, paddingTop:0, paddingLeft:'3%',paddingRight:'3%'}} >
        <Typography style={classes.p}>
                PhD Students <br></br><br></br><br/>
                Nedialko Bradinoff <br/>(2021-current)<br></br><br/>
                Wenkui Liu<br/> (2019-current) <br></br><br/>
                Tomas Berggren<br/> (2015-2020)<br></br><br/>
            </Typography>
            </Grid>
            <Grid item xs={6} sm={6} style={{margin:0, paddingTop:0, paddingLeft:'3%',paddingRight:'3%'}} >
            <Typography style={classes.p}>
               Postdocs <br></br><br></br><br/>
               Nathan Hayford <br/> (2023-current)<br></br><br/>
               Ahmad Barhoumi <br/>(2023-current) <br></br><br/>
               Roger Van Pesski <br/>(2023-2024)<br></br><br/>
               Diane Holcomb <br/>(2018-2020) <br></br>  <br/>
               Benjamin Fahs<br/> (2018-2019) <br></br>   <br/>
            </Typography>
            </Grid>
            </Grid>
        </Grid>
        </Grid>
            <Grid item xs={12} sm={6}  style={{paddingLeft:'3%',borderLeft: '0.03em solid grey'}}>
            
            <div align="center">
                   <img src={Aztec} style={{align:'center',margin:'auto',color: '#333333',justify:'center',width:'80%'}}></img>  
            </div>
            <Typography style={classes.p}>
                The picture above shows a random domino tiling of an Aztec diamond, with a doubly periodic weighting. Recently, we have discovered interesting integrable structures for such models. A thorough asymptotic study of the  example in the picture was performed by my former PhD student Tomas Berggren in his thesis. These are some first steps in the understanding of such models and one of the goals of the PiRaT project is to continue this investigation.
 
            </Typography>


            <Typography variant="h4" style={classes.h1}> Research group at KTH</Typography>
           <Typography style={classes.p}>
                    Together with Kurt Johansson, Gaultier Lambert and Kevin Schnelli I am part on the focus group on
                     "Random Matrices, Stochastics Models and Analysis" within the Mathematics Department at KTH.  
                     <br/><br/>
                     The group is and has been financially supported by different grants from  the Swedish Research council,
                     the Göran Gustafsson Foundation, the Knut and Allice Wallenberg foundation and the European Research Council.
                     With this support we have been able to hire graduate students and postdocs in our group, 
                     and will be interested in new recruitments in the future.
                     <br/><br/>
                     We run a Random Matrix Theory seminar every Tuesday. 
                     <br/><br/>
                     Click <Link   href="https://www.math.kth.se/RMSMA/" > here</Link> for more details on our group and it activities
           </Typography>
          
            </Grid>
            
            </Grid>
       
            <Grid item xs={12} sm={12}  style={{paddingLeft:'3%',borderLeft: '0.03em solid grey'}}>
            <Typography variant="h4" style={classes.h1}>
            Popular Research Description
        </Typography>
            <Typography style={classes.p}>
            One remarkable fact of nature is that large systems consisting of random small parts behave in predictable ways. For example, the objects around us appear to be static and not chaotic, 
            but they are all built out of atoms that behave quite erratically individually. How is it that this chaotic behavior at very small scales, is not present at the 
            large scale that we live in? How can it be that a large collection of individual random particles form a static object at large? 
            For mathematicians there is a great challenge to build a grounded mathematical framework to study the mechanisms behind such phenomena. We often  do this by studying large classes of mathematical models that are ”simple” enough so that
            one can compute or analyze  their behavior in detail. A deeper understanding often leads to (sometimes unexpected) new connections and predictions that, in turn, serve as inspiration for further developments in related sciences.
             </Typography>
            <Typography style={classes.p}>
             
Let us look at an example that many are familiar with. In high school we learn that many histograms of data 
(from every day examples such as the heights of individuals  to errors in lab measurements) are shaped like a bell. 
Why this bell-shaped curve appears for such data is a classical question that is well-understood nowadays.
A first proof that this bell-shaped curve really does appear, and that it is given by a Gaussian, was proved by De Moivre in 1736  for repeated coin tosses. Throw a coin a 50 times and count  the number of times you throw tail. <img src={bell} style={{float:'right',margin:'2%',color: '#333333',justify:'center',width:'30%'}}/>
This will likely be  a number close to 25. In the figure on the right 
there is a plot for the the probabilities for all possible outcomes. The closer the outcome is to 25, the higher the bar and the more likely that outcome is to appear. Note that 
the bars together take the shape of a bell (the red curve). If we would increase the number of tosses, this effect will be even more pronounced and 
the bell-shaped curve is an even better approximation. 
By the  Central Limit Theorem (Lindeberg 1920) the bell-shaped curve is universal and will appear in many other situations; the coin tosses are only a mathematical model that is computable, but can be replaced by other types of random events, 
as long as they are <span style={{fontFamily:'italic'}}>independent</span>: the outcome of a single coin toss does not influence the outcome of the other tosses. Mathematicians have thus proved that a bell-shaped curve appears,
computed its exact shape and then also proved it is indeed universal by understanding the mechanism behind this phenomenon. Also, now that we have the exact shape we are in the position
to study further properties.
</Typography>
            <Typography style={classes.p}>
           Physical systems with many interacting particles, like atoms and electrons, are far more difficult than coin tosses. Indeed, the particles in that system can be thought of 
                as random, but certainly not independent: they interact with each other through the forces of physics. To develop
                an understanding for such systems we can no longer require independence, and have to extend the classical theories and develop new and modern mathematics. 
</Typography>
            <Typography style={classes.p}> Let us turn to an example that has been studied by various colleague mathematicians in the past decades.
            Take a hexagon and cover it with a given type of tiles. The tiles that we allow have a lozenge shape (perhaps you will recognize their shapes as a kind of licorice used as a cough medicine).
            </Typography>

            
         <div align='center'>
                   <img src={Lozplustile} style={{color: '#333333',width:'55%'}}> 
                   </img>
                   </div>
            
            <Typography style={classes.p}>
There are of course many ways of tiling the hexagon and we will pick one at random. We will put all possible tilings in a bag and then pick one random out of this bag (in other words, the probabilities are uniformly distributed). 
We think of such a random tiling of systems of random particles where the lozenge are the microscopic elements. 
At this point it is far from clear why this is a good model that has similar featuers as complex physical systems described above. 
As a first step, it is not difficult to see that the lozenges are not independent.
 Indeed, if you throw some lozenges at several places on the hexagon try to 
complete the tiling, you will find that in many cases it will not be possible to do this without having overlapping tiles (which we do not allow). 
This means that certain configurations are simply not allowed and this brings a dependence in the system. 
Remarkably, it is possible to make these arguments more precise and one can show there is an analogy between random tilings and discrete coulomb gases:
roughly speaking, lozenges of a given type can be thought 
of as a random configuration of electrons that repel each other through the usual electric force.
</Typography>
<Typography style={classes.p}>

The question that we would like to answer is the following: How will a random tiling look like? 
This may seem like a dull question at first.  Indeed, if we take a few samples we do not see much structure. 
</Typography>
<div align='center'>
                   <img src={SmallH1} style={{borderColor:"grey",  borderTop: 'solid',borderBottom: 'solid',borderLeft: 'solid',width:'20%'}}></img>
                   <img src={SmallH2} style={{borderColor:"grey",borderTop: 'solid',borderBottom: 'solid',width:'20%'}}></img>
                   <img src={SmallH3} style={{borderColor:"grey",borderTop: 'solid',borderBottom: 'solid',width:'20%'}}></img>
                   <img src={SmallH4} style={{borderColor:"grey",borderTop: 'solid',borderBottom: 'solid',borderRight: 'solid',width:'20%'}}></img>  
            </div>
            <Typography style={classes.p}>Each picture looks different from the other. The situation is vey similar to rolling a dice where the outcome can be any of the number 1 to 6, and not much can be said about  the outcome of a single throw.
             But this is because the hexagon is very small. How about we take a very large hexagon 
(or, equivalently, we make the size of the tiles very small)? Then we obtain a picure like the one below:
  
</Typography>
<div align='center'>
<img src={BigHcircle} style={{border:'solid',borderColor:"grey",margin:'auto',color: '#333333',justify:'center',width:'70%'}}></img>
</div>
<Typography style={classes.p}>
    Now there is a lot more structure! For instance, each of the corners there is 
    only type of tile appearing and  the randomness is remaining 
    inside a circle. We say that the corners are 'frozen'. Did you expect that such frozen corners would appear?
    </Typography><Typography style={classes.p}>
    There are many interesting questions that one can study. Can one prove that there is indeed a circle appearing and why is it that the corners are frozen? 
    And what are the fluctuations?   <img src={TW} style={{float:'right',margin:'2%',color: '#333333',justify:'center',width:'30%'}}/> For instance, after we have proved that there is indeed a circle appearing in the limit when the size of the hexagon becomes large, 
    what can we say about the fluctuations near the edge of the random regions in the large hexagons where we expect this circle to appear? It turns out that the fluctuations near the edge
    are described by the so-called Tracy-Widom distribution, shown in the figure on the right.  This is a new law, found and studied by Tracy and Widom in the 90s, and is different from the bell-shaped curve that appears 
    in the classical Central Limit Theorem described above. But just as this bell-shaped curve, the Tracy-Widom distribution is expected to be a universal
    law that 
    appears in many interesting systems in physics, including certain random growth models. The scope of this new law is still a highly active  research topic.  There are also several  other fascinating properties 
    of this tiling model that have been studied with deep connections 
    to theoretical physics. It is remarkable that  this seemingly simple model  has many rich features 
    that connect to many other complex systems in nature.
    </Typography>
            <Typography style={classes.p}>
     Finding and understanding new behavior in  random microscopic systems, as well as proving
    their universal nature, is an important theme in my research activities.
</Typography>
</Grid>

        
        
        </div>
        )
    }
}

export default Research;